import { createClient } from '@supabase/supabase-js';

// Use environment variables for configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseKey) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
  throw new Error('Missing required environment variables for Supabase configuration.');
}

const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;